import { useState, useEffect, useMemo } from 'react';
import debounce from 'lodash.debounce';
import adminAPI from '../../API/adminAPI';

export const useCheckEmail = ({ email, type }) => {
    const { getUserByEmail } = adminAPI;
    const [ response, setResponse ] = useState({ valid: false, message: '' });

    useEffect(() => {
        if (type !== 'new') return;
        const emailRE = new RegExp(/[^@]+@[^@]+\.[^@]+/);

        const handleGetUserByEmail = debounce(async (email) => {
            try {
                const { data } = await getUserByEmail(email);

                if (data === true) {
                    setResponse({ valid: false, message: 'Email already in use'});
                } else {
                    setResponse({ valid: true, message: '' });
                };
            } catch (err) {
                console.error(err);
                setResponse({ valid: false, message: 'Email check failed' });
            };
        }, 500);

        if (email && emailRE.test(email)) handleGetUserByEmail(email);

        return () => handleGetUserByEmail.cancel();
    },[email, response?.valid, setResponse]);

    return useMemo(() => response, [response]);
};